import Toolbar, { Separator } from 'common/components/Toolbar'
import ConfigDetailButton from 'features/RegulatoryTools/HCAMCA/Components/TabsAndModals/ConfigDetailButton'
import TableViewToggle from 'features/RegulatoryTools/HCAMCA/Components/TabsAndModals/TableViewToggle'
import { HMCATableViewMode } from 'features/RegulatoryTools/HCAMCA/Components/Tables'
import CSVExportButton from 'features/RiskManagement/Components/Tables/Toolbar/CSVExportButton'
import { JobMutationArgs, JobMutationTrigger } from 'common/contexts/types'

interface ITabsAndModals {
  tableMode: HMCATableViewMode
  setTableMode: (value: HMCATableViewMode) => void
  mutationTrigger: JobMutationTrigger
  exportParams: JobMutationArgs
}

const TabsAndModals = ({
  tableMode,
  setTableMode,
  mutationTrigger,
  exportParams
}: ITabsAndModals) => {
  return (
    <Toolbar className='py-1'>
      <TableViewToggle tableMode={tableMode} setTableMode={setTableMode} />
      <Separator className='mr-1' />
      <CSVExportButton
        mutationTrigger={mutationTrigger}
        exportParams={exportParams}
      />
      <div className='flex-1' />
      <ConfigDetailButton />
    </Toolbar>
  )
}

export default TabsAndModals
